/**
 * Centralized event tracking for Meta Pixel + GA4.
 * Safe no-op if globals are not initialized (e.g., IDs missing in env).
 */

export function fbq(...args) {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    try {
      window.fbq(...args);
    } catch (e) {
      console.warn("[fbq] error", e);
    }
  }
}

export function gtag(...args) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    try {
      window.gtag(...args);
    } catch (e) {
      console.warn("[gtag] error", e);
    }
  }
}

export function trackPageView(path) {
  fbq("track", "PageView");
  gtag("event", "page_view", { page_path: path });
}

export function trackViewContent() {
  fbq("track", "ViewContent", {
    content_name: "Pequeños Platos Ebook",
    content_category: "Digital Ebook",
    currency: "USD",
    value: 9.9,
  });
  gtag("event", "view_item", {
    currency: "USD",
    value: 9.9,
    items: [
      {
        item_id: "ebook_main",
        item_name: "Pequeños Platos Ebook",
        price: 9.9,
        quantity: 1,
      },
    ],
  });
}

export function trackInitiateCheckout(sourceCta = "unknown") {
  fbq("track", "InitiateCheckout", {
    content_name: "Pequeños Platos Ebook",
    currency: "USD",
    value: 9.9,
    num_items: 1,
  });
  gtag("event", "begin_checkout", {
    currency: "USD",
    value: 9.9,
    cta_source: sourceCta,
    items: [
      {
        item_id: "ebook_main",
        item_name: "Pequeños Platos Ebook",
        price: 9.9,
        quantity: 1,
      },
    ],
  });
}

export function trackPurchase({ sessionId, valueUsd = 9.9 }) {
  fbq("track", "Purchase", {
    content_name: "Pequeños Platos Ebook",
    currency: "USD",
    value: Number(valueUsd) || 9.9,
    num_items: 1,
  });
  gtag("event", "purchase", {
    transaction_id: sessionId,
    currency: "USD",
    value: Number(valueUsd) || 9.9,
    items: [
      {
        item_id: "ebook_main",
        item_name: "Pequeños Platos Ebook",
        price: Number(valueUsd) || 9.9,
        quantity: 1,
      },
    ],
  });
}

export function trackLead(email) {
  fbq("track", "Lead", { content_category: "Free Sample Recipe" });
  gtag("event", "generate_lead", { method: "email", value: 0 });
  return email;
}
